import { apiFetch } from '@/platform/lib/api';
import type { HostGuidePatch, HostGuideSnapshot } from '@communio/host-guide';

export type { HostGuidePatch, HostGuideSnapshot } from '@communio/host-guide';

export function fetchHostGuide(): Promise<HostGuideSnapshot> {
  return apiFetch<HostGuideSnapshot>('/saas/me/host-guide');
}

export function patchHostGuide(body: HostGuidePatch): Promise<HostGuideSnapshot> {
  return apiFetch<HostGuideSnapshot>('/saas/me/host-guide', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}
